import { Box, Stack, Typography } from '@mui/material';
import React from 'react';

export default function DashboardPageHeader({
  title,
  subtitle,
  icon: Icon,
  actions,
  button,
  actionsBelow = false,
  keepTitleOnOneLine = false
}) {
  return (
    <Stack
      direction={actionsBelow ? 'column' : { xs: 'column', sm: 'row' }}
      alignItems={actionsBelow ? 'flex-start' : { xs: 'flex-start', sm: 'center' }}
      justifyContent="space-between"
      gap={2}
      mb={3.5}
    >
      <Box sx={{ minWidth: 0 }}>
        <Stack direction="row" alignItems="center" gap={1.25}>
          {Icon && (
            <Box
              sx={{
                alignItems: 'center',
                bgcolor: 'primary.light',
                borderRadius: 2.5,
                color: 'primary.main',
                display: 'flex',
                height: 42,
                justifyContent: 'center',
                width: 42
              }}
            >
              <Icon sx={{ fontSize: 23 }} />
            </Box>
          )}
          <Typography
            variant="h4"
            component="h1"
            sx={keepTitleOnOneLine ? { whiteSpace: 'nowrap' } : undefined}
          >
            {title}
          </Typography>
        </Stack>
        {subtitle && (
          <Typography color="text.secondary" sx={{ mt: 0.75, maxWidth: 720 }}>
            {subtitle}
          </Typography>
        )}
      </Box>
      {(actions || button) && (
        <Box sx={{ flexShrink: 0, width: actionsBelow ? '100%' : 'auto' }}>
          {actions || button}
        </Box>
      )}
    </Stack>
  );
}
